import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => {
  return {
    customInputWhite: {
      color: "#fff !important",
    },
    container: {
      padding: 0,
      backgroundColor: "transparent",
      width: "100%",
      "& .MuiPaper-root": {
        backgroundColor: "transparent",
      },
      "& .MuiFormControl-root": {
        marginTop: "20px",
      },
    },
    stepsLayout: {
      display: "flex",
      flexDirection: "row",
      gap: "20px",
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    stepsSidebar: {
      width: "280px",
      flexShrink: 0,
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      backgroundColor: "#131313",
      borderRadius: 16,
      padding: "24px",
      boxSizing: "border-box",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    sidebarLogo: {
      width: "120px",
      height: "auto",
      marginBottom: "16px",
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    sidebarText: {
      color: "#FFFFFF",
      fontSize: "22px",
      fontWeight: 600,
      marginBottom: "20px",
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    stepsContent: {
      flex: 1,
      minWidth: 0,
      backgroundColor: "#131313",
      borderRadius: 16,
      padding: "40px",
      boxSizing: "border-box",
      [theme.breakpoints.down("sm")]: {
        padding: "32px 14px",
      },
    },
    title: {
      color: "#FFFFFF",
      fontSize: "24px",
      fontWeight: 600,
      marginBottom: "24px",
      textAlign: "center",
      "& span": {
        color: "#FFFFFF",
      },
      marginTop: "0px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "20px",
      },
    },
    menuItem: {
      color: "#ffffff",
      backgroundColor: "#1a1a1a", // фон
      minHeight: "20px",
      fontSize: "14px",
      "&:hover": {
        backgroundColor: "#333333",
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
      },
    },
    selectRoot: {
      color: "#ffffff", // текст селекта
    },
    paper: {
      backgroundColor: "#1a1a1a", // фон випадаючого списку
    },
    icon: {
      color: "#ffffff", // 👈 колір стрілочки
    },
    dropdownPaper: {
      color: "pink",
      padding: "0px",
      height: "170px",
      maxHeight: "200px",
    },
    selectionCard: {
      borderRadius: "12px",
      width: "100%",
    },
    cardTitle: {
      color: "#ffffff",
      textAlign: "center",
      marginBottom: "30px",
      fontSize: "18px",
      fontWeight: 500,
    },
    optionsContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      gap: "20px",
      marginBottom: "20px",
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        gap: "12px",
      },
    },
    optionCard: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "16px",
      cursor: "pointer",
      transition: "transform 0.3s ease",
      flex: 1,
      "&:hover": {
        transform: "scale(1.01)",
      },
      [theme.breakpoints.down("sm")]: {
        gap: "12px",
      },
    },
    optionImageWrapper: {
      position: "relative",
      width: "390px",
      height: "300px",
      borderRadius: "8px",
      overflow: "hidden",
      flexShrink: 0,
      border: "2px solid transparent",
      transition: "border-color 0.3s ease",
      [theme.breakpoints.down("sm")]: {
        width: "152px",
        height: "112px",
      },
    },
    selectedImageWrapper: {
      border: "2px solid #F05D94",
    },
    optionDivider: {
      width: "100%",
      height: "1px",
      backgroundColor: "#FFFFFF1A",
      marginTop: "32px",
      marginBottom: "32px",
    },
    selectedCard: {
      // selected state handled by selectedImageWrapper
    },
    optionImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "flex-end",
      width: "100%",
      [theme.breakpoints.down("xs")]: {},
    },
    button: {
      backgroundColor: "#FE5A97",
      color: "#ffffff",
      borderRadius: "6px",
      padding: "10px 25px",
      fontWeight: "bold",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "#d45aa8",
      },
      "&:disabled": {
        backgroundColor: "#FE5A9740",
        color: "#FFFFFF80",
        opacity: 1,
      },
      [theme.breakpoints.down("xs")]: {
        padding: "5px 10px",
        fontSize: "10px",
      },
    },
    buttonIcon: {
      marginLeft: "5px",
    },
    optionLabel: {
      color: props => (props.selected ? "#F05D94" : "#FFFFFF"),
      cursor: "pointer",
      textAlign: "left",
      fontSize: "20px",
      fontWeight: 600,
      transition: "color 0.3s ease",
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px",
        fontWeight: 500,
      },
    },
    customInput: {
      padding: "13px 16px",
      color: "#FFFFFF",
      fontFamily: "Baloo Tamma 2",
      fontSize: "16px",
      fontWeight: 400,
      borderRadius: "8px",
      border: "1px solid #A3A3A3",
      outline: "none",
      backgroundColor: "transparent",
      "&:focus": {
        outline: "1px solid #A3A3A3",
        outlineOffset: "0px",
      },
      "&:before, &:after": {
        display: "none",
      },
      "& .MuiInputBase-input": {
        padding: 0,
        color: "#FFFFFF",
        "&::placeholder": {
          color: "#A3A3A3",
          opacity: 1,
        },
      },
      "& .MuiSelect-icon": {
        color: "#FFFFFF",
      },
    },
    customLabel: {
      marginBottom: "12px",
      fontSize: "14px",
      fontWeight: 600,
      color: "#FFFFFF",
      backgroundColor: "transparent",
      "&$focused": { color: "#FFFFFF" },
      "&$shrink": { color: "#FFFFFF" },
      "&$disabled": { color: "#FFFFFF" },
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
      },
    },
    formControl: {
      marginTop: "20px",
    },
    focused: {},
    shrink: {},
    disabled: {},

    viewerLabel: {
      backgroundColor: props => (props.selected ? "#f06ec4" : "#666666"),
    },
    suggestionsScrollContainer: {
      overflowY: "auto",
      overscrollBehavior: "contain",
      // Custom scrollbar styles (same as InAppNotifications)
      "&::-webkit-scrollbar": {
        width: "12px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#1F1F1F",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#FFD0E1",
        width: "8px",
        borderRadius: "6px",
        border: "2px solid #1F1F1F",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#FFD0E1",
      },
      scrollbarWidth: "thin",
      scrollbarColor: "#FFD0E1 #1F1F1F",
    },
  };
});

export default useStyles;
